export default __webpack_public_path__ + "static/media/singingBowl.e99b2ea9.wav";